import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const gallerySlice = createSlice({
  name: 'gallerySliceName',
  initialState,
  reducers: {
    addGallery: (state) => {
      state.loading = true;
    },
    getGallery: (state) => {
      state.loading = true;
    },
    getOneGallery: (state) => {
      state.loading = true;
    },

    successGallery: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    removeGallery: (state) => {
      state.loading = true;
    },
    updateGallery: (state) => {
      state.loading = true;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { addGallery, removeGallery, updateGallery, getGallery, successGallery, getOneGallery } = gallerySlice.actions

export default gallerySlice.reducer